
export enum SessionStorageKeys {
    LoginFunnelState = "loginFunnelState",
    AccountUserInformation = "accountUserInformation",
    LoginResponse = "loginResponse",
    LastAuthenticatedPageVisited = "lastAuthenticatedPageVisited",
    LastIdleInterruptTime = "lastIdleInterruptTime",
}